<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <receipt-account-table />
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import ReceiptAccountTable from './ReceiptAccountTable.vue'

  export default {
    name: 'ReceiptAccountView',
    components: { ReceiptAccountTable }
  }
</script>



// WEBPACK FOOTER //
// src/views/payment/bank/ReceiptAccount.vue